import { Component, input } from "@angular/core";
import { TopbarLanguageSelectionComponent } from "./topbar-language-selection/topbar-language-selection.component";
import { TopbarSchoolSwitchingComponent } from "./topbar-school-switching/topbar-school-switching.component";
import { TopbarSearchComponent } from "./topbar-search/topbar-search.component";
import { TopbarUserProfileComponent } from "./topbar-user-profile/topbar-user-profile.component";

@Component({
	selector: "app-topbar",
	imports: [
		TopbarSchoolSwitchingComponent,
		TopbarSearchComponent,
		TopbarLanguageSelectionComponent,
		TopbarUserProfileComponent,
	],
	templateUrl: "./topbar.component.html",
})
export class TopbarComponent {
	internalView = input(false);
}
